(function() {

    $(document).on('click', '[data-confirm]', function(event) {
        if (!confirm($(this).data('confirm'))) {
            event.preventDefault();
        }
    });

})();